import { render } from "./SwHeaderIconBtn.vue?vue&type=template&id=25b95b43"
import script from "./SwHeaderIconBtn.vue?vue&type=script&lang=js"
export * from "./SwHeaderIconBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__